import { appHttpRequest } from '../../../utils/AppHttpRequest';
import { ciHttpRequest } from '../../../utils/CiHttpRequest';

import { ISaleSoSearch, ISaleSoDetail, ISaleSoStatistics } from './vrmBillSaleSoType';

class SaleSoService {
	async total(searchVo: ISaleSoSearch) {
		const apiUrl = '/vrm2/sale/total';
		return await appHttpRequest.post<ISaleSoStatistics>(apiUrl, searchVo);
	}
	async one(id: string,userBranch:string) {
		const apiUrl =userBranch=='vrm'?`/vrm2/sale/findById/${id}`: `/ci-storage/sale/findById/${id}`;
		return await userBranch=='vrm'?appHttpRequest.get<ISaleSoDetail>(apiUrl):ciHttpRequest.get<ISaleSoDetail>(apiUrl);
	}
}

export const saleSoService = new SaleSoService();
